"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _closeButton = _interopRequireDefault(require("./close-button"));
var _contentColumn = _interopRequireDefault(require("../content-column"));
var _heading = _interopRequireDefault(require("./heading"));
require("./top-sheet.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Modal element which slides down from the top of the viewport when opened, and slides back
 * up when closed. TopSheet is to be used in conjunction with ModalProvider.
 * TopSheet does not create a mask or manage focus; to get an accessible modal with
 * a mask see <a href='/components/modals'>ModalProvider</a> documentation.
 *
 * TopSheet is intended to be used as a way to provide context or detail for another element
 * or flow on the page. It is similar in some ways to a Tooltip, but is good for cases when
 * there is too much content for a Tooltip. It should be quick and easy to scan content.
 */
var TopSheet = function TopSheet(_ref) {
  var children = _ref.children,
    className = _ref.className,
    closeProps = _ref.closeProps,
    headingChildren = _ref.headingChildren,
    headingProps = _ref.headingProps,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
    _ref$standardLayout = _ref.standardLayout,
    standardLayout = _ref$standardLayout === void 0 ? true : _ref$standardLayout;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-topSheet', className)
  }, !standardLayout ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], closeProps), /*#__PURE__*/_react["default"].createElement(_heading["default"], _extends({}, headingProps, {
    children: headingChildren
  })), children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], closeProps), /*#__PURE__*/_react["default"].createElement(_contentColumn["default"], {
    className: "mb4 md-mb7",
    size: "md"
  }, /*#__PURE__*/_react["default"].createElement(_heading["default"], _extends({}, headingProps, {
    children: headingChildren
  })), children)));
};
TopSheet.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Child elements that will render within the top sheet. */
  children: _propTypes["default"].any,
  /** CSS class set on the top level dom element of the TopSheet. */
  className: _propTypes["default"].string,
  /** Props assigned to the close button. Pass on `onClick` here for a close callback. */
  closeProps: _propTypes["default"].object,
  /** Optional child elements to be rendered within a pre-styled heading. This may be omitted in favor of a heading passed in as part of the children. */
  headingChildren: _propTypes["default"].any,
  /** Optional props to be passed to the pre-styled heading element, to overwrite existing styles/behavior. */
  headingProps: _propTypes["default"].object,
  /** An optional prop to hide the close button */
  hideCloseButton: _propTypes["default"].bool,
  /** A boolean that determines if the default styling should be applied to the top sheet. */
  standardLayout: _propTypes["default"].bool
} : {};
TopSheet.displayName = 'TopSheet';
var _default = exports["default"] = TopSheet;